<div
    class="virtual-try-on-variant-item"
    [class.align-left]="titleAlignment === 'LEFT'"
    [class.align-right]="titleAlignment === 'RIGHT'">
    @if (product) {
    <div
        #clickZone
        class="vto-variant-responsive"
        title="{{ product.variant }} - {{ product.price | hCurrency : formatCurrency }}"
        (click)="clickVariant(product.sku)"
        (keydown)="keydownVariant($event, index)"
        [tabindex]="selected ? 0 : -1"
        [class.mobile]="!isDesktop"
        role="radio"
        [attr.aria-checked]="selected"
        [class.checked-vto-variant]="selected && isDesktop">
        <div class="vto-item-picture">
            <img
                aria-hidden="true"
                class="variant-responsive"
                [src]="getScene7Url(product.image)"
                alt=""
                hImageErrorDefault
                (error)="handleErrorImage()"
                [class.no-image]="isBreakImage"
                loading="lazy" />
        </div>
    </div>
    } @if (selected) {
    <div class="vto-variant-title">
        <span class="paragraph-small">{{ product.variant }}</span> |
        <h-price
            [price]="product.price"
            [weight]="'bold'"
            [hasPrimaryColor]="false"
            [format]="formatCurrency"
            [size]="'small'"></h-price>
    </div>
    }
</div>
